import { API } from '../api';
import axiosInstance from '../axiosConfig';

/**
 * Admin CRUD for a professional's own standalone services (the service
 * source of the professional-first booking flow). The public read lives in
 * axios/publicFlow (`getPublicProfessionalServices`).
 */

/** @returns {Promise<import('../../flow/types').ProfessionalServiceDTO[]>} all active for that professional + location */
export const getProfessionalServices = async (professionalId, locationId) => {
  const response = await axiosInstance.get(
    `${API.PROFESSIONAL_SERVICE.FIND_ALL}${professionalId}/${locationId}`
  );
  return response?.data?.data || [];
};

/**
 * @param {{title: string, durationInMinutes: number, bufferTimeInMinutes: number, cost: string,
 *   venue: string, description: string, image: string, order?: number, isLive?: boolean,
 *   isPublic?: boolean, categoryId?: number, professionalId: number, locationId: number,
 *   businessId: number}} payload - `categoryId` is optional; an update can change it but not clear it
 */
export const addProfessionalService = async (payload) => {
  const response = await axiosInstance.post(API.PROFESSIONAL_SERVICE.ADD, payload);
  return response?.data?.data;
};

/** Same body as `addProfessionalService` plus `id`. */
export const updateProfessionalService = async (payload) => {
  const response = await axiosInstance.patch(API.PROFESSIONAL_SERVICE.UPDATE, payload);
  return response?.data?.data;
};

/** Soft delete. */
export const deleteProfessionalService = async (id) => {
  const response = await axiosInstance.delete(`${API.PROFESSIONAL_SERVICE.DELETE}${id}`);
  return response?.data?.data;
};
